<template>
  <div class="el-col-24">
    <h5 class="warp-title">角色管理</h5>
    <div class="search-type mb15">
      <router-link v-if="querybtn.rolemanage_add === 1" class="blue" :to="{name: 'RoleAdd'}" tag="span">
        <el-button class="search-type" size="small" type="primary">新增</el-button>
      </router-link>
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        align="center"
        style="width: 100%">
        <el-table-column
          label="角色名称"
          prop="roleName"
          align="center">
        </el-table-column>
        <el-table-column
          label="生成时间"
          prop="createTime"
          align="center">
        </el-table-column>
        <el-table-column
          label="最后操作时间"
          prop="updateTime"
          align="center">
        </el-table-column>
        <el-table-column
          label="状态"
          width="120"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">正常</span>
            <span v-else-if="scope.row.status === 1">禁用</span>
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="remark"
          align="center"
          width="320">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right">
         <template slot-scope="scope">
            <div class="operating">
              <router-link v-if="querybtn.rolemanage_edit === 1" class="green cursor" :to="{name: 'RoleEdit', query:{id: scope.row.id, state: 1}}">编辑</router-link>
              <span v-if="querybtn.rolemanage_delete === 1">
                <span v-if="scope.row.status === 0" class="red" @click="resetOperating(scope.row.id, scope.row.status, '禁用')">禁用</span>
                <span v-else class="green" @click="resetOperating(scope.row.id, scope.row.status, '恢复')">恢复</span>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { queryRolePage, deleteRole } from '../../../api/power/role'
import { queryButtonPermission } from '../../../api/public/auth'
export default {
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      querybtn: {}
    }
  },
  methods: {
    initData () {
      let data = {
        currPage: this.currentPage,
        pageSize: this.pageSize
      }
      queryRolePage(data).then(info => {
        let data = info.data
        if (data.resultCode === 0) {
          this.total = data.totalCount
          this.tableData = data.resultData
          let pageNum = Math.ceil(data.totalCount / this.pageSize)
          if (pageNum !== 0 && this.currentPage > pageNum) {
            this.currentPage = pageNum
            this.initData()
          }
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
    },
    currentChange (val) {
      this.currentPage = val
      this.initData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.initData()
    },
    resetOperating (id, status, val) {
      this.$confirm(`确认${val}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          id,
          status
        }
        deleteRole(param).then(res => {
          if (res.data.resultCode === 0) {
            this.$message.success(res.data.resultMessage)
            this.initData()
          } else {
            this.$message.error(res.data.resultMessage)
          }
        })
      })
    },
    seach () {
      this.currentPage = 1
      this.initData()
    }
  },
  mounted () {
    this.initData()
  }
}
</script>
<style lang="less" scoped>
a{
  color: #16BB5A;
  text-decoration: underline;
}
.el-button+.el-button{
  margin-left: 0;
}
.el-button--small{
  padding: 9px 10px;
}
.mb15{
  margin-bottom: 15px;
}
.el-col-24{
  font-size: 14px;
  // width: 800px;
}
.search-type{
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Power/Role/Index.vue